/* unplugin-vue-components disabled */import script from "./PropsFilterBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./PropsFilterBlock.vue?vue&type=script&setup=true&lang=ts"

import "./PropsFilterBlock.vue?vue&type=style&index=0&id=b22c0742&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b22c0742"]])

export default __exports__